<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back"/>
			<img src="@/images/center_text9.png" class="per_right_1name"/>
		</div>
		<div class="per_right_2">
			<div class="right-filter">
				<el-form :inline="true" :model="form">
					<el-form-item label="题目类型：">
						<el-select v-model="form.topicType" placeholder="题目类型" style='width: 120px;' clearable>
							<el-option :label="item.label" :value="item.value" :key="item.value" v-for='item in types'></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="题目名称：">
						<el-input v-model="form.question" placeholder="题目名称" style='width: 150px;' clearable></el-input>
					</el-form-item>
					<div class="feedback_button" @click="onSubmit">
						<img src="@/images/zy_button.png" class="feedback_back" />
						<span>查询</span>
					</div>
				</el-form>
			</div>
			<div class="app_right_bottom">
				<el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="作业错题" name='first'>
						<div class="noinfo" v-if='qusetionlist.length<=0'>暂无作业错题</div>
						<div v-for="(item,index) in qusetionlist">
							<div :class="(item.topicType == 1||item.topicType == 3)?'table-wrap single':'table-wrap'">
								<div class="questionTitle questionTitle_only">
									{{index+1}}、{{item.question}}
									<div class="questionTitle_more" @click="toveiw(item,'task')"><i class="el-icon-tickets"></i> 查看详情</div>
								</div>
							</div>
						</div>
						<div class="table-page" v-if='qusetionlist.length>0'>
							<el-pagination @current-change='questionPageChange' background layout="prev, pager, next" :page='questionPage' :total="questiontotalrow">
							</el-pagination>
						</div>
					</el-tab-pane>
					<el-tab-pane label="考核错题" name='second'>
						<div class="noinfo" v-if='examlist.length<=0'>暂无考核错题</div>
						<div v-for="(item,index) in examlist">
							<div :class="(item.topicType == 1||item.topicType == 3)?'table-wrap single':'table-wrap'">
								<div class="questionTitle questionTitle_only">
									{{index+1}}、{{item.question}}
									<div class="questionTitle_more" @click="toveiw(item,'exam')"><i class="el-icon-tickets"></i> 查看详情</div>
								</div>
							</div>
						</div>
						<div class="table-page" v-if='examlist.length>0'>
							<el-pagination @current-change='examPageChange' background layout="prev, pager, next" :page='examPage' :total="examtotalrow">
							</el-pagination>
						</div>
					</el-tab-pane>
					<el-tab-pane label="实验错题" name='third' v-if='false'>
						<div class="noinfo" v-if='experlist.length<=0'>暂无实验错题</div>
						<div v-for="(item,index) in experlist">
							<div :class="(item.topicType == 1||item.topicType == 3)?'table-wrap single':'table-wrap'">
								<div class="questionTitle questionTitle_only">
									{{index+1}}、{{item.question}}
									<div class="questionTitle_more" @click="toveiw(item,'exper')"><i class="el-icon-tickets"></i> 查看详情</div>
								</div>
							</div>
						</div>
						<div class="table-page" v-if='experlist.length>0'>
							<el-pagination @current-change='experPageChange' background layout="prev, pager, next" :page='experPage' :total="expertotalrow">
							</el-pagination>
						</div>
					</el-tab-pane>
					<el-tab-pane label="自测错题" name='four'>
						<div class="noinfo" v-if='testlist.length<=0'>暂无自测错题</div>
						<div v-for="(item,index) in testlist">
							<div :class="(item.topicType == 1||item.topicType == 3)?'table-wrap single':'table-wrap'">
								<div class="questionTitle questionTitle_only">
									{{index+1}}、{{item.question}}
									<div class="questionTitle_more" @click="toveiw(item,'test')"><i class="el-icon-tickets"></i> 查看详情</div>
								</div>
							</div>
						</div>
						<div class="table-page" v-if='testlist.length>0'>
							<el-pagination @current-change='testPageChange' background layout="prev, pager, next" :page='testPage' :total="testtotalrow">
							</el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<el-dialog title="查看详情" :visible.sync="viewDialog" width="850px" :close-on-click-modal="false">
			<div style="max-height: 500px;overflow-y: auto;padding:  10px;" class="hiddenScroll">
				<div v-for="(item,index) in viewlist">
					<div :class="(item.topicType == 1||item.topicType == 3)?'table-wrap single':'table-wrap'">
						<div class="questionTitle questionTitle_info">
							{{index+1}}、
							<span v-if="item.topicType == 4">{{item.question | spliceQuestion}}</span>
							<span v-if="item.topicType != 4">{{item.question}}</span>
							<span class="maincolor">（<span v-if="item.topicType == it.value" v-for='it in types'>{{it.label}}题</span>）</span>
							<div v-if="item.isFile == '1'" class="filebox" style="margin: 20px 0 0 0;">
								<div class="fileboxname">图片/视频：</div>
								<div>
									<span :key='file.id' v-for="(file,fileindex) in item.files">
									<video style="width: 150px; height: 150px" :src="baseurl + file.url" v-if="file.url.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image fit="fill" style="width: 150px; height: 150px" :src="baseurl + file.url" :preview-src-list="[baseurl + file.url]" v-else>
									</el-image>
									</span>
								</div>
							</div>
							<div class="questionTitle_more">
								出错次数：{{item.error_count}}次
							</div>
						</div>
						<div v-if="item.topicType == 1">
							<div class="questionAnswers" v-for="(it,i) in item.answerlist">
								<div class="questionLabel questionLabel0">
									<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
										<div class="inCircle"></div>
									</div>
								</div>
								<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
								<span v-if="it.type == '2'">
											<br /><img :src="baseurl+it.value" alt="" />
										</span>
								</span>
							</div>
						</div>
						<div v-if="item.topicType == 2">
							<div class="questionAnswers" v-for="(it,i) in item.answerlist">
								<div class="questionLabel questionLabel0">
									<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
										<div class="inCircle"></div>
									</div>
								</div>
								<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
								<span v-if="it.type == '2'">
											<br /><img :src="baseurl+it.value" alt="" />
										</span>
								</span>
							</div>
						</div>
						<div v-if="item.topicType == 3">
							<div class="questionAnswers" v-for="(it,i) in item.answerlist">
								<div class="questionLabel questionLabel0">
									<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
										<div class="inCircle"></div>
									</div>
								</div>
								<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
								<span v-if="it.type == '2'">
											<br /><img :src="baseurl+it.value" alt="" />
										</span>
								</span>
							</div>
						</div>
						<div class="questionFooter" v-if="item.topicType == 1 || item.topicType == 2 || item.topicType == 3">
							我的答案：{{item.userAnswer}}&nbsp;&nbsp;
							<i class="iconfont iconcuo" v-if="item.chooseRight == '0'" style="color: #F56C6C;"></i>
							<i class="iconfont icondui" v-if="item.chooseRight == '1'" style="color: #00B43C;"></i>
						</div>
						<div class="questionFooter" v-if="item.topicType == 4">
							我的答案：{{item.userAnswer}}
						</div>
						<div class="questionFooter" v-if="item.topicType == 5">
							<div v-html="getAnswer(item)"></div>
						</div>
						<div class="fileArrbox" v-if="item.userAnswerFilearr && item.userAnswerFilearr.length>0">
							<div class="uploadFile" @click.stop="formPreview(file)" v-for="(file,index) in item.userAnswerFilearr">
								<img src="@/images/word.png" />
								<div class="p1">
									{{file.name}}
								</div>
								<div class="p2">
									{{file.size | filesize}}
								</div>
							</div>
							<div style="clear: both;"></div>
						</div>
						<div class="questionFooter" v-if="item.topicType == 4">
							参考答案：<span v-for="(it,i) in item.answerlist">{{it.value}}&nbsp;&nbsp;</span>
						</div>
						<div class="questionFooter" v-if="item.topicType != 4">
							参考答案：{{item.answer}}
						</div>
						<div class="questionFooter" v-if="item.topicType == 5">
							关键词：<span v-for="(it,i) in item.answerlist">{{it.value}}&nbsp;&nbsp;</span>
						</div>
						<div class="questionFooter">
							解析：{{item.analysis }}
						</div>
						<div class="questionFooter" v-show='item.comment'>
							教师评语：{{item.comment }}
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="viewDialog = false">确定</el-button>
			</div>
			<el-dialog :title="viewName==''?'预览':viewName" :visible.sync="viewShow" append-to-body>
				<div class="viewIframe" v-if="viewShow" v-loading="viewShowLoading">
					<iframe :src="playUrl" v-if="!viewAideoShow"  @load="viewShowLoading = false"></iframe>
					<audio :src="playUrl" v-if="viewAideoShow" controls="controls"></audio>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="viewShow = false">确定</el-button>
				</div>
			</el-dialog>
		</el-dialog>
	</div>
</template>

<script>
	import { downloadFile } from "@/utils/oss.js"
	import { topiclist, getUserTaskErrorTopic, getUserErrorInfo, getUserExamErrorTopic, getUserExamErrorInfo, getUserErrorTopic, getExperErrorInfo , getUserSeltTestTopic , getUserSeltTestTopicDetail} from '@/api/topic.js'
	export default {
		data() {
			return {
				pageSize: 10,
				questiontotalrow: 0,
				questionPage: 1,
				qusetionlist: [],
				examtotalrow: 0,
				examPage: 1,
				examlist: [],
				expertotalrow: 0,
				experPage: 1,
				experlist: [],
				testtotalrow: 0,
				testPage: 1,
				testlist: [],
				activeName: 'first',
				viewDialog: false,
				viewType: 'first',
				viewlist: [],

				form: {
					question: '',
					topicType: '',
				},
				types: [{
					value: '1',
					label: '单选'
				}, {
					value: '2',
					label: '多选'
				}, {
					value: '3',
					label: '判断'
				}, {
					value: '4',
					label: '填空'
				}, {
					value: '5',
					label: '简答'
				}],
				//文件
				playUrl: '',
				viewName: '',
				viewShowLoading: true,
				viewShow: false,
				viewAideoShow: false,
				viewopen: window.config.VUE_PDF_FILE,
			}
		},
		created() {
			this.getTopicinfo();
			this.getExaminfo();
			this.getExperinfo();
			this.getTestinfo();
		},
		methods: {
			getAnswer(item) {
				if(item.userAnswer) {
					var answerlist = item.answerlist;
					var answerStr = '我的答案：';
					var userAnswer = item.userAnswer;
					answerlist.map(answer => {
						userAnswer = userAnswer.split(answer.value).join('<span style="color: #e64242;">' + answer.value + '</span>');
					})
					return answerStr + userAnswer;
				} else {
					return '';
				}
			},
			formPreview(file) {
				var url = file.url;
				var fileUrl = url;
				var fileName = file.name;
				var filetype = file.url.substring(file.url.lastIndexOf('.') + 1);
				this.viewAideoShow = false;
				if(filetype == 'doc' || filetype == 'docx') {
					var playUrl = this.baseurl + url;
					playUrl = this.viewopen + encodeURIComponent(window.btoa(playUrl));
					this.playUrl = playUrl;
					this.viewName = file.name;
					this.viewShow = true;
					this.viewShowLoading = true;
				} else {
					var playUrl = this.baseurl + url;
					this.playUrl = playUrl;
					this.viewName = file.name;
					this.viewShow = true;
					if(filetype == 'mp3' || filetype == 'wav') {
						this.viewAideoShow = true;
					}
				}
			},
			toveiw(item, check) {
				var data = {
					topicId: item.topicId,
					type: item.type,
				}
				if(check == 'task') {
					getUserErrorInfo(data).then(res => {
						if(res.code == 0) {
							if(res.data.listData.length > 0) {
								this.openView(item, res.data.listData)
							}
						}
					})
				}
				if(check == 'exam') {
					getUserExamErrorInfo(data).then(res => {
						if(res.code == 0) {
							if(res.data.listData.length > 0) {
								this.openView(item, res.data.listData)
							}
						}
					})
				}
				if(check == 'exper') {
					getExperErrorInfo(data).then(res => {
						if(res.code == 0) {
							if(res.data.listData.length > 0) {
								this.openView(item, res.data.listData)
							}
						}
					})
				}
				if(check == 'test') {
					getUserSeltTestTopicDetail(data).then(res => {
						if(res.code == 0) {
							if(res.data.length  > 0) {
								this.openView(item, res.data)
							}
						}
					})
				}
			},
			openView(item, listData) {
				var viewlist = [];
				var question = {
					question: item.question,
					answer: item.answer,
					analysis: item.analysis,
					topicType: item.topicType,
					isFile: item.isFile,
					fileName: item.fileName,
					optionA: item.optionA,
					optionB: item.optionB,
					optionC: item.optionC,
					optionD: item.optionD,
					optionE: item.optionE,
					optionF: item.optionF,
				};
				if(question.isFile == 1 && question.fileName != null) {
					var files = JSON.parse(question.fileName);
					question.files = files;
				}
				if(question.topicType == 5 && question.userAnswerFile && question.userAnswerFile != '') {
					question.userAnswerFilearr = JSON.parse(question.userAnswerFile);
					question.userAnswerFile = question.userAnswerFile;
				}
				var answerlist = [];
				if(question.optionA != '' && question.optionA != null) {
					if(question.optionA.indexOf('@') == -1) {
						answerlist[0] = {
							type: '1',
							label: 'A',
							value: question.optionA,
						}
					} else {
						answerlist[0] = {
							type: '2',
							label: 'A',
							value: question.optionA.slice(1),
						}
					}
				}
				if(question.optionB != '' && question.optionB != null) {
					if(question.optionB.indexOf('@') == -1) {
						answerlist[1] = {
							type: '1',
							label: 'B',
							value: question.optionB,
						}
					} else {
						answerlist[1] = {
							type: '2',
							label: 'B',
							value: question.optionB.slice(1),
						}
					}
				}
				if(question.optionC != '' && question.optionC != null) {
					if(question.optionC.indexOf('@') == -1) {
						answerlist[2] = {
							type: '1',
							label: 'C',
							value: question.optionC,
						}
					} else {
						answerlist[2] = {
							type: '2',
							label: 'C',
							value: question.optionC.slice(1),
						}
					}
				}
				if(question.optionD != '' && question.optionD != null) {
					if(question.optionD.indexOf('@') == -1) {
						answerlist[3] = {
							type: '1',
							label: 'D',
							value: question.optionD,
						}
					} else {
						answerlist[3] = {
							type: '2',
							label: 'D',
							value: question.optionD.slice(1),
						}
					}
				}
				if(question.optionE != '' && question.optionE != null) {
					if(question.optionE.indexOf('@') == -1) {
						answerlist[4] = {
							type: '1',
							label: 'E',
							value: question.optionE,
						}
					} else {
						answerlist[4] = {
							type: '2',
							label: 'E',
							value: question.optionE.slice(1),
						}
					}
				}
				if(question.optionF != '' && question.optionF != null) {
					if(question.optionF.indexOf('@') == -1) {
						answerlist[5] = {
							type: '1',
							label: 'F',
							value: question.optionF,
						}
					} else {
						answerlist[5] = {
							type: '2',
							label: 'F',
							value: question.optionF.slice(1),
						}
					}
				}
				question.answerlist = answerlist;
				listData.map(it => {
					var newItem = Object.assign({}, question);
					newItem.userAnswer = it.userAnswer;
					newItem.from_name = it.name;
					newItem.error_count = it.count;
					if(newItem.topicType != 4 && newItem.topicType != 5) {
						if(!it.userAnswer) {
							newItem.choose = [];
						} else {
							newItem.choose = it.userAnswer.split('')
						}
					}
					viewlist.push(newItem);
				})
				this.viewlist = viewlist;
				this.viewType = 'cloud';
				this.viewDialog = true;
			},
			handleClick() {
				this.form = {
					question: '',
					topicType: '',
				}
				this.onSubmit()
			},

			experPageChange(page) {
				this.experPage = page;
				this.getExperinfo()
			},
			getExperinfo() {
				var data = {
					pageSize: this.pageSize,
					page: this.experPage,
					question: this.form.question,
					topicType: this.form.topicType,
				}
				getUserErrorTopic(data).then(res => {
					if(res.code == "0") {
						const {
							data
						} = res;
						this.experlist = res.data.listData;
						this.expertotalrow = res.data.totalRow;
					}
				})
			},
			examPageChange() {
				this.examPage = page;
				this.getExaminfo()
			},
			getExaminfo() {
				var data = {
					pageSize: this.pageSize,
					page: this.examPage,
					question: this.form.question,
					topicType: this.form.topicType,
				}
				getUserExamErrorTopic(data).then(res => {
					if(res.code == 0) {
						const {
							data
						} = res;
						this.examlist = res.data.listData;
						this.examtotalrow = res.data.totalRow;
					}
				})
			},
			questionPageChange(page) {
				this.questionPage = page;
				this.getTopicinfo()
			},
			getTopicinfo() {
				var data = {
					pageSize: this.pageSize,
					page: this.questionPage,
					question: this.form.question,
					topicType: this.form.topicType,
				}
				getUserTaskErrorTopic(data).then(res => {
					if(res.code == 0) {
						this.qusetionlist = res.data.listData;
						this.questiontotalrow = res.data.totalRow;
					}
				})
			},
			testPageChange() {
				this.testPage = page;
				this.getTestinfo()
			},
			getTestinfo() {
				var data = {
					pageSize: this.pageSize,
					page: this.testPage,
					question: this.form.question,
					topicType: this.form.topicType,
				}
				getUserSeltTestTopic(data).then(res => {
					if(res.code == 0) {
						this.testlist = res.data.listData;
						this.testtotalrow = res.data.totalRow;
					}
				})
			},
			onSubmit() {
				this.questionPage = 1;
				this.examPage = 1;
				this.testPage = 1;
				this.experPage = 1;
				this.getTopicinfo();
				this.getExaminfo();
				this.getExperinfo();
				this.getTestinfo();
			},
		},
	};
</script>

<style>

</style>